import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import tools from 'data/common/tools';
import { getHomes } from '../../../data/Homes/actions';

const logoAplus = require('images/icons/logo_aplus.png');
const logoEnerdom = require('images/icons/logo_enerdom.png');
const logoFhe = require('images/icons/logo_fhe.png');
const logoSoleco = require('images/icons/logo_soleco.png');
const logoViebrock = require('images/icons/logo_viebrock.png');

class Home extends PureComponent {
    static propTypes = {
        getHomes: PropTypes.func.isRequired,
        Homes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        classes: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshHomes();
    }

    refreshHomes = () => {
        const { getHomes } = this.props;
        this.setState({ loading: true });
        return getHomes()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `/fhe/home/detail/${rowData.homeId}` });
    };

    renderActions = memoizeOne(profile => {
        const userRights = profile.getIn(['user_rights', 'fhe'], []);

        let actions = {
            row: [],
            toolbar: []
        };
        if (profile.get('admin') || userRights.includes('homeDetails')) {
            actions.row.push({
                icon: ViewIcon,
                onClick: this.navigateToDetail,
                tooltip: Translator.translate('general.showDetail')
            });
        }
        return actions;
    });

    renderColumns = memoizeOne(profile => {
        const { classes } = this.props;
        const userRights = profile.getIn(['user_rights', 'fhe'], []);

        return [
            {
                title: Translator.translate(`general.table.column.boxId`, Translator.translate(`fhe.centerName`)),
                name: 'boxId'
            },
            {
                title: Translator.translate('general.table.column.homeId'),
                name: 'homeId',
                defaultSort: 'desc'
            },
            {
                title: Translator.translate('general.table.column.label'),
                name: 'label',
                action: (profile.get('admin') || userRights.includes('homeDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate('general.showDetail')
                }
            },
            {
                title: Translator.translate('general.table.column.brand'),
                name: 'brand',
                render: (row, data, value) => {
                    let res = null;
                    switch (value) {
                        case 'aplusbox':
                            res = <img src={logoAplus} alt="Aplusbox" className={classes.brandIcon} />;
                            break;
                        case 'enerdom':
                            res = <img src={logoEnerdom} alt="Enerdom" className={classes.brandIcon} />;
                            break;
                        case 'fullhomeenergy':
                            res = <img src={logoFhe} alt="Fullhomeenergy" className={classes.brandIcon} />;
                            break;
                        case 'solecofrance':
                            res = <img src={logoSoleco} alt="Solecofrance" className={classes.brandIcon} />;
                            break;
                        case 'viebrockhaus':
                            res = <img src={logoViebrock} alt="Viebrockhaus" className={classes.brandIcon} />;
                            break;
                    }
                    return res;
                }
            },
            {
                title: Translator.translate('general.table.column.macAddress'),
                name: 'macAddress',
                width: 150,
                customFilter: tools.filterMacAddress
            },
            {
                title: Translator.translate('general.table.column.firmwareVersion'),
                name: 'firmwareVersion',
                customSort: tools.sortVersion
            },
            {
                title: Translator.translate('general.table.column.provisionedDate'),
                name: 'provisionedDate'
            }
        ];
    });

    renderData = memoizeOne(Homes => {
        let result = [];
        Homes.map((Home, HomeId) => {
            result.push({
                homeId: parseInt(HomeId),
                boxId: Home.get('boxId') ? parseInt(Home.get('boxId')) : null,
                label: Home.get('label'),
                brand: Home.get('brand'),
                macAddress:
                    Home.get('macAddress') &&
                    Home.get('macAddress')
                        .match(/.{1,2}/g)
                        .join(':'),
                provisionedDate: Home.get('provisionedDate'),
                firmwareVersion: Home.get('firmwareVersion')
            });
        });
        return result;
    });

    render() {
        const { loading } = this.state;
        const { Homes, profile } = this.props;

        return (
            <FHETable
                idTable="installerDetailHomes"
                columns={this.renderColumns(profile)}
                data={this.renderData(Homes)}
                actions={this.renderActions(profile)}
                minified
                isLoading={loading}
                emptyDataSourceMessage={Translator.translate('generic.home.table.body.emptyDataSourceMessage')}
            />
        );
    }
}

function mapStateToProps(state, props) {
    let Homes = state.environments.fhe.data.Homes.get('list');
    state.environments.fhe.data.Boxes.get('list').map(Box => {
        if (Box.get('homeId') !== null && ['active', 'provisioned'].indexOf(Box.get('boxState')) !== -1 && Homes.has(Box.get('homeId').toString())) {
            Homes = Homes.mergeIn([Box.get('homeId').toString()], Box);
        }
    });
    const InstallerHomes = Homes.filter(home => {
        return home.get('installerId') === parseInt(props.match.params.installerId);
    });
    return {
        profile: state.data.user,
        Homes: InstallerHomes,
        initialized: state.environments.fhe.data.Homes.get('initialized')
    };
}

const styles = theme => ({
    checkIcon: {
        color: theme.palette.success.main
    },
    freeSpaceBarRoot: {
        height: 10
    },
    freeSpaceBarError: {
        borderRadius: 20,
        backgroundColor: theme.palette.error.main
    },
    freeSpaceBarWarning: {
        borderRadius: 20,
        backgroundColor: theme.palette.warning.main
    },
    freeSpaceBarSuccess: {
        borderRadius: 20,
        backgroundColor: theme.palette.success.main
    },
    brandIcon: {
        width: 80
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getHomes }, dispatch)
    )(withStyles(styles, { withTheme: true })(Home))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Installer/Table/TableHomes.js